import { forwardRef } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@rtkwlf/pro-solid-svg-icons/faCircleInfo';

import { Box } from '@packages/fenrir/components/box';
import { Stack } from '@packages/fenrir/components/stack';
import { Typography } from '@packages/fenrir/components/typography';

export type EmptyResultMessages = {
  title: string;
  description?: string;
};

export const EmptyResult = forwardRef<HTMLDivElement, EmptyResultMessages>(
  ({ title, description }, ref) => {
    return (
      <Stack width="100%" ref={ref} padding={5}>
        <Box textAlign="center" sx={{ color: 'text.secondary' }}>
          <FontAwesomeIcon icon={faCircleInfo} size="2x" />
        </Box>
        <Typography textAlign="center" variant="subtitle1">
          {title}
        </Typography>
        <Typography textAlign="center" variant="body2">
          {description}
        </Typography>
      </Stack>
    );
  },
);
EmptyResult.displayName = 'EmptyResult';
